import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import Box from "@mui/material/Box";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import StaffTable from "../Components/Staff/StaffTable";
import StaffDialogBox from "../Components/Staff/StaffDialogBox";
import { Button } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import Scaffold from "../Components/Layout/Scaffold";

const Staff = () => {
  let [hide, setHide] = useState(true);

  let [filter, setfilter] = useState<any>({});
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [textInput, setTextInput] = useState("");

  const handleTextInputChange = (event: any) => {
    setTextInput(event.target.value);
  };

  function changeFilters(key: string, value: string) {
    setfilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }


  function editDialogClose() {
    setEditDialogVisibility(false);
    changeFilters("timestamp", "" + Date.now());
  }

  return (
    <Scaffold
      title="Staff"
      actions={[
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": {
              maxWidth: "75ch",
            },
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-search"
            type="search"
            label="Search"
            variant="outlined"
            inputProps={{
              style: {
                width: "300px",
                fontSize: "14px",
              },
            }}
            size="small"
            placeholder="Enter search keyword"
            value={textInput}
            onChange={handleTextInputChange}
          />
        </Box>,
        <Button
          endIcon={<SearchOutlined />}
          className="mx-2"
          variant="contained"
          color="secondary"
          onClick={() => {
            changeFilters("keyword", "" + textInput);
          }}>
          Search
        </Button>
      ]}
      mainAction={<Button variant="contained"
        color="primary"
        onClick={() => {
          setEditDialogVisibility(true);
        }}
        startIcon={<AddIcon fontSize="small" />}
      >
        Create
      </Button>}
    >
      <>
      <StaffTable filter={filter} />
      <StaffDialogBox
        open={editDialogVisibility}
        onClose={editDialogClose}
        data={{}}
        dialogAction={EDialogAction.create}
      />
      </>
    </Scaffold>
  );
};

export default Staff;
